const yup = require("yup");
const moment = require('moment');
const eighteenYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 18))


const validations = {
  weight: yup.string().required("Please enter your weight").test(
  "weight",
  "Please enter a valid weight.",
  val => {
    return val && val > 0
  }),
  bustSize: yup.string().required("Please enter your bust size"),
  hairColor: yup.string().required("Please enter your hair color "),
  height: yup.string().required("Please enter your height"),
  zodiacSign: yup.string().required("Please select your zodiac sign"),
  eyeColor: yup.string().required("Please select your eye color"),
  bodyType: yup.string().required("Please select your body type"),
  experience: yup.string().required("Please select your experience level"),
  gender: yup.string().required("Please select your gender"),
  birthday: yup.string().required("Please enter your birthday").test('birthday', 'Must be 18 years or older', function validate(birthday) {
    return moment(birthday).isSame(moment(eighteenYearsAgo)) || moment(moment(eighteenYearsAgo)).isAfter(birthday)
  })
};

export default validations;
